import { HTMLAttributes } from 'react';
import { cn } from 'src/shared/lib/utils';

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-sm bg-muted', className)} {...props} />;
}

export { Skeleton };
